import { render, staticRenderFns } from "./PostShareModal.vue?vue&type=template&id=07617018&"
import script from "./PostShareModal.vue?vue&type=script&lang=js&"
export * from "./PostShareModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports